import { Controller } from "@hotwired/stimulus";

// Fetches an organization's template selects into #template-data whenever the org dropdown
// changes. That dropdown is #team-select, which initializers.js.erb binds as a select2 ajax
// widget, so the "change" here is select2's own `.trigger("change")` and not a native event -
// a data-action would never see it. Namespaced so disconnect() removes only what connect() added.
export default class extends Controller {
  static get targets() { return ["teamSelect", "output"]; }
  static get values() { return { templatesUrl: String }; }

  connect() {
    // select2 announces its selection change as a jQuery event (see the class comment) -- stays
    // jQuery-wrapped, a data-action/addEventListener would never see it.
    $(this.teamSelectTarget).on("change.adminBulkGiftImport", () => this.fetchTemplates());
  }

  disconnect() {
    $(this.teamSelectTarget).off("change.adminBulkGiftImport");
  }

  fetchTemplates() {
    // select2 keeps the underlying <select>'s own value in sync, so the native property reads the
    // same thing $(...).find(":selected").val() did.
    const organizationId = this.teamSelectTarget.value;
    const url = this.templatesUrlValue.replace("0", organizationId);

    fetch(url).
      then(response => response.text()).
      then(html => {
        // Server-rendered HTML from our own origin: Admin::Organizations::TemplatesController#index
        // renders shared/_template_select, whose only content comes from label_tag/select_tag/
        // options_from_collection_for_select -- Rails' own tag builders, which escape. No raw/
        // html_safe/`!=` anywhere in the partial.
        this.outputTarget.innerHTML = html;
      }).
      catch(this.logFailedCall);
  }

  logFailedCall(response) {
    console.warn(response);
  }
}
